import React from "react";

const Logo = () => {
  return (
    <svg
      className="brand_logo"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 1046.15 189.71"
    >
      <script xmlns="" />
      <script xmlns="" />
      <path
        className="st0"
        d="M1046.15,132.8h-29.2V24.55h-64.72V0h93.92v132.8Z"
        fill="#3e29ff"
      />
      <g>
        <path d="M0,54.31h29.2v108.24h64.72v24.55H0V54.31Z" />
        <path d="M152.32,88.34c30.32,0,49.84,20.09,49.84,50.77s-19.52,50.59-49.84,50.59-49.66-20.08-49.66-50.59,19.53-50.77,49.66-50.77ZM152.32,169.81c18.04,0,23.43-15.44,23.43-30.69s-5.39-30.87-23.43-30.87-23.25,15.44-23.25,30.87,5.39,30.69,23.25,30.69Z" />
        <path d="M282.88,124.8c-1.67-10.79-8.55-16.55-19.53-16.55-16.92,0-22.5,17.11-22.5,31.25s5.39,30.32,21.94,30.32c12.27,0,19.34-7.81,21.02-19.53h25.48c-3.35,25.48-21.02,39.43-46.31,39.43-29.02,0-48.55-20.46-48.55-49.29s17.85-52.08,49.1-52.08c22.69,0,43.52,11.9,45.2,36.46h-25.85Z" />
        <path d="M324.72,54.31h26.41v71.23s33.29-34.59,33.29-34.59h31.25l-36.27,35.34,40.36,60.82h-31.99l-26.41-42.96-10.23,9.86v33.11h-26.41V54.31Z" />
        <path d="M428.13,90.95h25.11v13.39h.56c6.69-10.79,18.23-16,29.38-16,28.08,0,35.15,15.81,35.15,39.62v59.14h-26.41v-54.31c0-15.81-4.65-23.62-16.92-23.62-14.32,0-20.46,8-20.46,27.53v50.4h-26.41v-96.15Z" />
        <path d="M534.88,54.31h29.2v108.24h64.72v24.55h-93.92V54.31Z" />
        <path d="M687.2,88.34c30.32,0,49.84,20.09,49.84,50.77s-19.52,50.59-49.84,50.59c-30.13,0-49.66-20.08-49.66-50.59s19.53-50.77,49.66-50.77ZM687.2,169.81c18.04,0,23.43-15.44,23.43-30.69s-5.39-30.87-23.43-30.87-23.25,15.44-23.25,30.87,5.39,30.69,23.25,30.69Z" />
        <path d="M817.75,124.8c-1.67-10.79-8.55-16.55-19.53-16.55-16.92,0-22.5,17.11-22.5,31.25s5.39,30.32,21.94,30.32c12.27,0,19.34-7.81,21.02-19.53h25.48c-3.35,25.48-21.02,39.43-46.31,39.43-29.02,0-48.55-20.46-48.55-49.29s17.85-52.08,49.1-52.08c22.69,0,43.52,11.9,45.2,36.46h-25.85Z" />
        <path d="M859.6,54.31h26.41v71.23s33.29-34.59,33.29-34.59h31.25l-36.27,35.34,40.36,60.82h-31.99l-26.41-42.96-10.23,9.86v33.11h-26.41V54.31Z" />
      </g>
    </svg>
  );
};

export default Logo;
